import { createFileRoute } from "@tanstack/react-router";
import { EverythingPage } from "@/features/everything/EverythingPage";

export const Route = createFileRoute("/_app/apps")({
  component: EverythingPage,
});
